import { render, staticRenderFns } from "./AdminComplaints.vue?vue&type=template&id=4b7c7459&"
import script from "./AdminComplaints.vue?vue&type=script&lang=js&"
export * from "./AdminComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports